import { render, staticRenderFns } from "./AppDrop.vue?vue&type=template&id=52cff9c0&scoped=true&"
import script from "./AppDrop.vue?vue&type=script&lang=js&"
export * from "./AppDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cff9c0",
  null
  
)

export default component.exports